import { authorSelected, searched, tagSelected } from "../filter/filterSlice";

const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  pageNo: 1,
};

const paginationSlice = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    paginationSelected: (state, action) => {
      state.pageNo = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(tagSelected, (state) => {
        state.pageNo = 1;
      })
      .addCase(authorSelected, (state) => {
        state.pageNo = 1;
      })
      .addCase(searched, (state) => {
        state.pageNo = 1;
      });
  },
});

export default paginationSlice.reducer;
export const { paginationSelected } = paginationSlice.actions;
